"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var dayjs = require("dayjs");
var IStrategy = require("./IStrategy");
var _require = require("../../utils/errors"),
  ThrottledNetworkError = _require.ThrottledNetworkError;
var DEBOUNCE = "DEBOUNCE";
var DebounceStrategy = /*#__PURE__*/function (_IStrategy) {
  function DebounceStrategy(config) {
    var _this;
    (0, _classCallCheck2["default"])(this, DebounceStrategy);
    _this = _callSuper(this, DebounceStrategy);
    (0, _defineProperty2["default"])(_this, "key", DEBOUNCE);
    (0, _defineProperty2["default"])(_this, "_requests", null);
    (0, _defineProperty2["default"])(_this, "_debounces", null);
    (0, _defineProperty2["default"])(_this, "_config", null);
    _this._config = config;
    _this._requests = {};
    _this._debounces = {};
    return _this;
  }
  (0, _inherits2["default"])(DebounceStrategy, _IStrategy);
  return (0, _createClass2["default"])(DebounceStrategy, [{
    key: "run",
    value: function run(url, overrides) {
      var _overrides$throttle,
        _overrides$throttle$t,
        _overrides$throttle2,
        _overrides$throttle$m,
        _overrides$throttle3,
        _this$_requests$url,
        _this2 = this;
      if (overrides !== null && overrides !== void 0 && (_overrides$throttle = overrides.throttle) !== null && _overrides$throttle !== void 0 && _overrides$throttle.disabled) {
        return Promise.resolve();
      }
      var timeDiff = this._requests[url] ? dayjs().diff(dayjs(this._requests[url].time), "seconds") : Number.MAX_SAFE_INTEGER;
      var timeThresholdForThrottling = (_overrides$throttle$t = overrides === null || overrides === void 0 || (_overrides$throttle2 = overrides.throttle) === null || _overrides$throttle2 === void 0 ? void 0 : _overrides$throttle2.thresholdSeconds) !== null && _overrides$throttle$t !== void 0 ? _overrides$throttle$t : this._config.get("network.throttle.thresholdInSeconds");
      var maxCalls = (_overrides$throttle$m = overrides === null || overrides === void 0 || (_overrides$throttle3 = overrides.throttle) === null || _overrides$throttle3 === void 0 ? void 0 : _overrides$throttle3.maxCalls) !== null && _overrides$throttle$m !== void 0 ? _overrides$throttle$m : this._config.get("network.throttle.maxCalls");
      if (timeDiff > timeThresholdForThrottling) {
        var _this$_debounces$url;
        (_this$_debounces$url = this._debounces[url]) === null || _this$_debounces$url === void 0 || _this$_debounces$url.reject();
        this._requests[url] = {
          time: dayjs().toISOString(),
          calls: 1
        };
        return Promise.resolve();
      }
      this._requests[url].calls += 1;
      if (((_this$_requests$url = this._requests[url]) === null || _this$_requests$url === void 0 ? void 0 : _this$_requests$url.calls) > maxCalls) {
        var _this$_debounces$url2;
        (_this$_debounces$url2 = this._debounces[url]) === null || _this$_debounces$url2 === void 0 || _this$_debounces$url2.reject();
        return new Promise(function (_resolve, _reject) {
          var timeout = null;
          var resolve = function resolve() {
            clearTimeout(timeout);
            _this2._debounces[url] = null;
            _resolve();
          };
          var reject = function reject() {
            clearTimeout(timeout);
            _this2._debounces[url] = null;
            _reject(new ThrottledNetworkError("Network endpoint called too many times"));
          };
          _this2._debounces[url] = {
            resolve: resolve,
            reject: reject
          };
          timeout = setTimeout(resolve, _this2._config.get("network.throttle.thresholdInSeconds") * 1000);
        });
      }
      return Promise.resolve();
    }
  }], [{
    key: "build",
    value: function build(config) {
      return new DebounceStrategy(config);
    }
  }]);
}(IStrategy);
exports = module.exports = DebounceStrategy;
module.exports.DEBOUNCE = DEBOUNCE;